// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
/* Store Custom Code - Start */
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    /* Store Custom Code - Start */
    accordion: {
        padding: {
            horizontal: pxToRemArray([20, 24]),
            vertical: pxToRemArray([20, 24]),
        },
        spacing: pxToRemArray([-1]),
    },
    button: {
        field: {
            enabled: false,
        },
    },
    common: {
        contentRadius: pxToRem(4),
    },
    layout: {
        contentWidth: 1312,
        spacing: {
            side: pxToRemArray([16, 24, 32, 48, 64]),
            content: pxToRemArray([20, 24, 32, 48, 64]),
            narrowContent: pxToRemArray([20, 24, 28, 32, 48]),
            spacedContent: pxToRemArray([24, 32, 48, 64, 80]),
        },
    },
    header: {
        height: pxToRemArray([74, null, 88, 102]),
        padding: pxToRemArray([12, null, 15]),
        itemSpacing: pxToRemArray([8, null, 40, 50, 60]),
        subItemSpacing: pxToRemArray([8, null, 30, 35, 40]),
        iconButton: {
            size: pxToRemArray([32, null, 24]),
            padding: pxToRemArray([4, null, 0]),
        },
    },
    menu: {
        panel: {
            largerRowPadding: pxToRem(16.5, 16),
            rowPadding: pxToRem(13.5, 16),
            rowWrapperPadding: pxToRem(12, 0),
        },
        mainNavigation: {
            height: pxToRemArray([38]),
            itemSpacing: pxToRemArray([32]),
            megaMenuFullWidth: true,
            underlineSize: pxToRem(2),
        },
        secondaryNavigation: {
            height: pxToRemArray([38]),
            itemSpacing: pxToRemArray([28]),
            iconSpacing: pxToRem(6),
        },
        megaMenuWithTabs: {
            spacing: pxToRem(18),
            tabs: {
                childSpacing: pxToRem(16),
                width: pxToRemArray([null, null, 288, 311]),
            },
            tabsContent: {
                spacing: pxToRem(30, 64),
            },
        },
    },
    /* Store Custom Code - End */
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
        /* Store Custom Code - Start */
        detail: {
            contentSpacing: pxToRem(20),
        },
        list: {
            contentSpacing: pxToRem(5),
        },
        /* Store Custom Code - End */
    },
    category: {
        image: {
            small: getImageSize(600, 600), // Store Custom Code
            large: getImageSize(600, 400), // Store Custom Code
        },
    },
    typography: {
        fontFamily: {
            /* Store Custom Code - Start */
            title: `"PT Serif", serif`,
            base: `"Lato", sans-serif`,
            /* Store Custom Code - End */
        },
        /* Store Custom Code - Start */
        lineHeight: {
            small: 1.26,
            large: 1.76,
        },
        /* Store Custom Code - End */
    },
};

export default design;
